import { Component } from '@angular/core';

@Component({
    selector: 'app-deposit',
    imports: [],
    templateUrl: './deposit.component.html',
    styleUrl: './deposit.component.scss'
})
export class DepositComponent {

}
